import { collection, getDocs, query, where, serverTimestamp } from 'firebase/firestore';
import { db } from './config';
import { createEducation } from './educationService';

/**
 * Seed education if the collection is empty
 */
export const seedEducation = async () => {
    try {
        // Check if education entries already exist
        const educationCollection = collection(db, 'education');
        const snapshot = await getDocs(educationCollection);

        if (snapshot.empty) {
            console.log('Seeding education collection...');

            // Define initial education entries
            const initialEducation = [
                {
                    institution: 'Jahangirnagar University',
                    degree: 'Master of Science (M.Sc.)',
                    fieldOfStudy: 'Computer Science',
                    location: 'Savar, Dhaka, Bangladesh',
                    startDate: '2017', // NOTE: start year estimated; graduation Apr 2019 per CV
                    endDate: '2019-04',
                    grade: '',
                    descriptions: [
                        'Advanced coursework in algorithms, artificial intelligence, and distributed systems.',
                        'Built research foundations later applied to AI/ML products and published work on intrusion detection in drone networks.'
                    ],
                    achievements: [],
                    website: 'https://juniv.edu',
                    institutionLogo: '',
                    order: 0
                },
                {
                    institution: 'Patuakhali Science & Technology University',
                    degree: 'Bachelor of Science (B.Sc.)',
                    fieldOfStudy: 'Computer Science & Engineering',
                    location: 'Patuakhali, Bangladesh',
                    startDate: '2007', // NOTE: start year estimated; graduation Nov 2011 per CV
                    endDate: '2011-11',
                    grade: '',
                    descriptions: [
                        'Built core foundations in software engineering, data structures, and computer architecture.',
                        'Active in competitive programming, leading to ACM NCPC 2010 participation as Team Leader.'
                    ],
                    achievements: [
                        'ACM NCPC 2010 — Programming Contest Team Leader'
                    ],
                    website: 'https://pstu.ac.bd',
                    institutionLogo: '',
                    order: 1
                }
            ];

            // Add each education entry
            for (const education of initialEducation) {
                await createEducation(education);
            }

            console.log('Education seeded successfully');
        } else {
            console.log('Education collection already has data, skipping seed');
        }
    } catch (error) {
        console.error('Error seeding education:', error);
    }
};

export default seedEducation; 